import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { getSessionId } from '../../helpers/storageUtils';
import { DestinosModels } from '../../Models/destinos';
import { TokenService } from '../../shared/services/token.service';
import { UtilsService } from '../utils.service';

@Injectable({
  providedIn: 'root',
})
export class DestinosService {
  tokenService = inject(TokenService);
  baseUrl = environment.URL_API_DETINOS;
  SESSION_ID = getSessionId().toString();
  private http = inject(HttpClient);
  private utils = inject(UtilsService);

  constructor() {}

  public getDestinos(session: string): Observable<DestinosModels> {
    const headers = this.utils.getHeaders(session || this.SESSION_ID);

    return this.http.get<DestinosModels>(this.baseUrl, { headers: headers });
  }
}
